import { Link } from "react-router-dom";
import SelectShop from '../../form/SelectShop.js';

function PanelSelectShop(props) {

   return (
       <div className="step">
           
               步驟2：選擇前往指定門市(必填)
               <a href={process.env.REACT_APP_URL_WEBSITE_SHOPLIST} target="_blank" rel="noopener noreferrer">&gt;門市資料 &lt;</a>
               <SelectShop districtsList={props.districtsList} onChange={props.onChange} ></SelectShop>
           
       </div>
   );
 }
 
export default PanelSelectShop;